const switchPalette = (tokens) => {
    return {
        knob: {
            size: {
                medium: tokens.switchKnobSizeM
            },
            background: {
                selected: {
                    default: tokens.switchKnobColorBgSelectedDefault,
                    hover: tokens.switchKnobColorBgSelectedHover,
                    disabled: tokens.switchKnobColorBgSelectedDisabled
                },
                unselected: {
                    default: tokens.switchKnobColorBgUnselectedDefault,
                    hover: tokens.switchKnobColorBgUnselectedHover,
                    disabled: tokens.switchKnobColorBgUnselectedDisabled
                }
            },
            border: {
                width: tokens.switchKnobBorderWidth,
                radius: tokens.switchKnobRadius,
                selected: {
                    default: tokens.switchKnobColorBorderSelectedDefault,
                    hover: tokens.switchKnobColorBorderSelectedHover,
                    disabled: tokens.switchKnobColorBorderSelectedDisabled
                },
                unselected: {
                    default: tokens.switchKnobColorBorderUnselectedDefault,
                    hover: tokens.switchKnobColorBorderUnselectedHover,
                    disabled: tokens.switchKnobColorBorderUnselectedDisabled
                }
            }
        },
        track: {
            size: {
                medium: {
                    width: tokens.switchTrackSizeMMinWidth,
                    height: tokens.switchTrackSizeMMinHeight
                }
            },
            background: {
                selected: {
                    default: tokens.switchTrackColorBgSelectedDefault,
                    hover: tokens.switchTrackColorBgSelectedHover,
                    disabled: tokens.switchTrackColorBgSelectedDisabled
                },
                unselected: {
                    default: tokens.switchTrackColorBgUnselectedDefault,
                    hover: tokens.switchTrackColorBgUnselectedHover,
                    disabled: tokens.switchTrackColorBgUnselectedDisabled
                }
            },
            border: {
                width: tokens.switchTrackBorderWidth,
                radius: tokens.switchTrackRadius,
                selected: {
                    default: tokens.switchTrackColorBorderSelectedDefault,
                    hover: tokens.switchTrackColorBorderSelectedHover,
                    disabled: tokens.switchTrackColorBorderSelectedDisabled
                },
                unselected: {
                    default: tokens.switchTrackColorBorderUnselectedDefault,
                    hover: tokens.switchTrackColorBorderUnselectedHover,
                    disabled: tokens.switchTrackColorBorderUnselectedDisabled
                }
            }
        }
    };
};
export default switchPalette;
//# sourceMappingURL=switch.js.map